import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <Box sx={{ 
      borderTop: '1px solid #eaeaea', 
      py: 5, 
      bgcolor: 'background.paper' 
    }}>
      <Container maxWidth="lg">
        <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: 'repeat(4, 1fr)' }, gap: 4, mb: 4 }}>
          {/* Logo and tagline */}
          <Box>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
              <img 
                src="/Finsense.png" 
                alt="Finsense Logo" 
                style={{ 
                  height: '32px',
                  width: 'auto',
                  marginRight: '12px'
                }} 
              />
            </Box>
          </Box>

          {/* Product links */}
          <Box>
            <Typography variant="subtitle1" fontWeight="bold" gutterBottom>Nuorodos</Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Typography 
                variant="body2" 
                color="text.secondary" 
                component={Link} 
                to="/"
                sx={{ textDecoration: 'none' }}
              >
                Pagrindinis
              </Typography>
              <Typography 
                variant="body2" 
                color="text.secondary" 
                component={Link} 
                to="/DUK"
                sx={{ textDecoration: 'none' }}
              >
                DUK
              </Typography>
              <Typography 
                variant="body2" 
                color="text.secondary" 
                component={Link} 
                to="/apie"
                sx={{ textDecoration: 'none' }}
              >
                Apie
              </Typography>
            </Box>
          </Box>
        </Box>

        {/* Copyright and social links */}
        <Box sx={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center',
          pt: 3,
          borderTop: '1px solid #eaeaea'
        }}>
          <Typography variant="body2" color="text.secondary">
            © 2025 Finsense. Visos teisės saugomos.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer; 